import { render } from "./TaxesSummary.vue?vue&type=template&id=73537ffe&scoped=true"
import script from "./TaxesSummary.vue?vue&type=script&lang=js"
export * from "./TaxesSummary.vue?vue&type=script&lang=js"

import "./TaxesSummary.vue?vue&type=style&index=0&id=73537ffe&lang=css"
import "./TaxesSummary.vue?vue&type=style&index=1&id=73537ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73537ffe"]])

export default __exports__